export const theme = {
    colors: {
        primary: "hsl(210, 95%, 49%)",
        primaryHover: "hsl(210, 95%, 56%)",
        primaryActive: "hsl(210, 95%, 64%)",

        border: "#ddd",
        white: "white",

        toggleDone: "hsl(120, 61%, 34%)",
        toggleDoneHover: "hsl(120, 61%, 39%)",

        remove: "hsl(348, 83%, 47%)",
        removeHover: "hsl(348, 83%, 52%)",

        disabled: "#ccc",
    },

    breakpoints: {
        mobile: "767px",
    },
};
